import { BottomSheetModalProvider as BottomSheetModalProviderFromGorhom } from "@-/com.npmjs.gorhom__bottom-sheet";
import {
  PortalContextBridgeScope,
  usePortalContextValues,
} from "@-/dev.improve.haniverse.components.ui.portal-context-bridge";
import { useSafeAreaInsets } from "@-/com.npmjs.react-native-safe-area-context";
import type { PropsWithChildren } from "react";
import { BottomSheetHostSafeAreaInsetsContext } from "#bottom-sheet-host-safe-area-insets";

/** Every sheet transport starts a fresh capture boundary, including nested modals. */
export function BottomSheetModalProvider({ children }: PropsWithChildren) {
  const inheritedValues = usePortalContextValues({ allowMissingScope: true });
  const hostInsets = useSafeAreaInsets();
  return (
    <BottomSheetHostSafeAreaInsetsContext value={hostInsets}>
      <BottomSheetModalProviderFromGorhom>
        <PortalContextBridgeScope inheritedValues={inheritedValues}>
          {children}
        </PortalContextBridgeScope>
      </BottomSheetModalProviderFromGorhom>
    </BottomSheetHostSafeAreaInsetsContext>
  );
}
